import { z } from 'zod'

export const priceOverrideUploadResponseSchema = z.object({
  id: z.string(),
  label: z.string(),
  status: z.string(),
  created_at: z.string(),
})

export type PriceOverrideUploadResponse = z.infer<typeof priceOverrideUploadResponseSchema>

export const priceOverrideUploadSchema = z.object({
  id: z.string(),
  label: z.string(),
  status: z.enum(['Pending', 'Failed', 'Success']),
  notes: z.string().nullable(),
  created_at: z.string(),
  updated_at: z.string(),
})

export type PriceOverrideUpload = z.infer<typeof priceOverrideUploadSchema>

export const priceOverrideUploadsResponseSchema = z.array(priceOverrideUploadSchema)
